// @ts-nocheck
import React, { useEffect, useState } from 'react'
// Component
import { DivFlex } from '../../../../components/Common/CellText'
// Style Component
import { ModalWrapper, TitleModal } from './PopupHandleDocumentIncomingStyled'
// Ant design
import { Button, Space } from 'antd'
// Mobx
import { inject, observer } from 'mobx-react'
// Other

import { ASSIGNEE_TYPE } from '../../../../constants'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../../../components/SelectGroupPopup/SelectGroupPopup'
// Import ActivityHistory
import ActivityHistory from './ActivityHistory' // Thêm import ActivityHistory

const PopupHandleHistoryIncoming = props => {
  const { internalDocumentStore, selectPeopleStore, documentCode } = props

  const {
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleCancelSelectGroup,
    clearSelected,
  } = selectPeopleStore

  const { isVisiblePopupHistoryDocument, handleCancelHistoryDocument } = props

  const onCancelModal = () => {
    handleCancelHistoryDocument()
    clearSelected()
  }

  return (
    <ModalWrapper
      onCancel={onCancelModal}
      maskClosable={false}
      footer={null}
      width={1200}
      wrapClassName="custom-modal-wrapper"
      title="Lịch sử hoạt động"
      visible={isVisiblePopupHistoryDocument}>
      {/* Hiển thị component ActivityHistory */}
      <ActivityHistory documentCode={documentCode} />

      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </ModalWrapper>
  )
}

PopupHandleHistoryIncoming.propTypes = {}

export default inject(
  'internalDocumentStore',
  'loadingAnimationStore',
  'selectPeopleStore'
)(observer(PopupHandleHistoryIncoming))
